import { FlagIcon } from "react-flag-kit";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IoPeopleCircle } from "react-icons/io5";
import { FaChalkboardUser } from "react-icons/fa6";

import { isDevs } from "../../utils/utils";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";

import {
  Container,
  DivLeft,
  ScheduleLanguageName,
  ScheduleDateTime,
  ScheduleLanguageDetails,
  ScheduleLanguagePeople,
  DivRight,
  WrapperIcons,
  WrapperButton,
  ButtonView,
  ButtonClassRoom,
} from "./styles";

function CardSchedule({ schedule }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);
  // const { nextClasses } = useSelector((state) => state.genericReducer);
  //
  // const [cancelAlertOpen, setCancelAlertOpen] = useState(false);
  // const [recurrentSchedule, setRecurrentSchedule] = useState(false);
  // const [recurrentScheduleId, setRecurrentScheduleId] = useState("");
  // const [recurrentScheduleEndDate, setRecurrentScheduleEndDate] = useState("");
  // const [sequentialScheduleCancelClasses, setSequentialScheduleCancelClasses] = useState([]);
  //
  // const closeCancelAlert = async () => setCancelAlertOpen(false);
  //
  // const cancelSubmit = async (message, cancelledBy, recurrentSchedule, cancelAllRecurrences) => {
  //   closeCancelAlert();
  //   await dispatch(initLoading());

  //   const atualDate = moment();
  //   let cancelObj = getCancelObj(schedule, message, cancelledBy, user?.role, recurrentSchedule, cancelAllRecurrences);

  //   await dispatch(postCancelClass(cancelObj));
  //   await dispatch(handleCalendarInitialParams("list", atualDate, atualDate, true));
  //   await dispatch(loadUserStorage());
  //   await dispatch(endLoading());
  // };
  //
  // const getCancelObj = (schedule, message, cancelledBy, role, recurrentSchedule, cancelAllRecurrences) => {
  //   if (role === "teacher") {
  //     return getTeacherCancelObj(schedule, message, cancelAllRecurrences);
  //   } else {
  //     return getOthersCancelObj(schedule, recurrentSchedule, message, cancelledBy, cancelAllRecurrences);
  //   }
  // };
  //
  // const getTeacherCancelObj = (schedule, message = "Cancel by User") => {
  //   const isFixed = schedule.allocationSchedule === "fixed";
  //   const cancelObj = { reason: message };
  //   if (isFixed) {
  //     cancelObj.allocationScheduleId = schedule.allocationScheduleId;
  //     cancelObj.reschedule = true;
  //   } else {
  //     cancelObj.sequentialScheduleId = schedule.sequentialScheduleId;
  //   }
  //   return cancelObj;
  // };
  //
  // const getOthersCancelObj = (
  //   schedule,
  //   cancelledBy,
  //   recurrentSchedule,
  //   cancelAllRecurrences,
  //   message = "Cancel by User",
  // ) => {
  //   const cancelObj = { reason: message, cancelledBy };
  //   if (recurrentSchedule && cancelAllRecurrences) {
  //     cancelObj.recurrentScheduleId = schedule.recurrentScheduleId;
  //   } else {
  //     cancelObj.sequentialScheduleId = schedule.sequentialScheduleId;
  //   }
  //   return cancelObj;
  // };
  //
  // const ConfirmedCardItem = () => {
  //   const isStudent = user?.role === "student";
  //   const isCanceled = schedule.status === "canceled";
  //   const isPending = schedule.status === "pending";
  //   const isAccepted = schedule.status === "accepted";
  //   const hasTeacher = !!schedule.teacher;
  //   const isDone = schedule.status === "done";
  //
  //   if (!isStudent && !hasTeacher) {
  //     return <h4 className={"scheduleWithoutTeacher"}>{t("WITHOUT_TEACHER")}</h4>;
  //   } else if ((isStudent && !isCanceled) || (isPending && hasTeacher) || isAccepted) {
  //     return (
  //       <h4 className={"scheduleConfirmed"}>
  //         {t("CARD_CLASS_CONFIRMED")}
  //         <i className="fa fa-check-circle-o"></i>
  //       </h4>
  //     );
  //   } else if (isDone) {
  //     return (
  //       <h4 className={"scheduleConfirmed"}>
  //         {t("CARD_CLASS_DONE")}
  //         <i className="fa fa-check-circle-o"></i>
  //       </h4>
  //     );
  //   } else {
  //     return <h4 className={"scheduleConfirmed"} />;
  //   }
  // };
  //
  // const CancelCardItem = () => {
  //   const isCanceled = schedule.status === "canceled";
  //   const iscanceledFree = schedule.status === "canceledFree";
  //   const isCanceledByLingo = schedule.status === "canceledLingo";
  //   const iscanceledFreeLingo = schedule.status === "canceledFreeLingo";
  //   const isNoShow = schedule.status === "noShow";
  //   const isPending = schedule.status === "pending";
  //   const isAccepted = schedule.status === "accepted";
  //
  //   if (isCanceled) {
  //     return <h4 className={"scheduleCanceledByOutLimit"}>{t("CANCELLED_OUT_lIMIT")}</h4>;
  //   } else if (isCanceledByLingo || iscanceledFreeLingo) {
  //     return <h4 className={"scheduleCanceled"}>{t("CANCELLED_LINGO")}</h4>;
  //   } else if (iscanceledFree) {
  //     return <h4 className={"scheduleCanceled"}>{t("CLASS_CANCELED")}</h4>;
  //   } else if (isNoShow) {
  //     return <h4 className={"scheduleIsNoShow"}>{t("NOSHOW")}</h4>;
  //   } else if (isPending || isAccepted) {
  //     if (schedule.type === "demo") {
  //       return <div className="scheduleCanceled" />;
  //     }
  //     return (
  //       <button className="cancelSchedule" onClick={setCancelModalValues}>
  //         {t("BTN_CANCEL")} <i className="fa fa-times-circle-o"></i>
  //       </button>
  //     );
  //   } else {
  //     return <div className="scheduleCanceled" />;
  //   }
  // };
  //
  // const setCancelModalValues = () => {
  //   const recurrentSchedule =
  //     user?.role === "teacher" || user?.role === "companyManager" ? true : schedule.recurrentSchedule;
  //   setCancelAlertOpen(true);
  //   setRecurrentSchedule(recurrentSchedule);
  //   getSequentialSchedules(recurrentSchedule, schedule);
  // };
  //
  // const getSequentialSchedules = (recurrentSchedule, schedule) => {
  //   // const classId = recurrentSchedule ? schedule?.recurrentScheduleId : schedule?.sequentialScheduleId;
  //   schedule && handleGetSequentialClasses(schedule, recurrentSchedule);
  // };
  //
  // const handleGetSequentialClasses = (schedule, recurrentSchedule) => {
  //   const pageNumber = 1;
  //   const pageSize = 100;
  //   const params = {
  //     pageNumber,
  //     pageSize,
  //     recurrentScheduleId: schedule?.recurrentScheduleId,
  //     sequentialScheduleId: schedule?.sequentialScheduleId,
  //   };
  //   dispatch(getSequentialClasses(params, recurrentSchedule))
  //     .then((res) => {
  //       res &&
  //         setSequentialScheduleCancelClasses(
  //           res.filter(
  //             (sequential) =>
  //               moment(sequential.scheduledDate).format("YYYY-MM-DD") ===
  //               moment(schedule.scheduledDate).format("YYYY-MM-DD"),
  //           ),
  //         );

  //       setRecurrentScheduleEndDate(res[res.length - 1]?.scheduledDate);
  //       setRecurrentScheduleId(res[0]?.recurrentScheduleId);
  //       // setAllSeqClasses(res);
  //     })
  //     .catch((err) => {
  //       console.log("ERROR ON GET SEQUENTIAL END DATE: ", err);
  //     });
  // };
  //
  // const isStudent = user?.role === "student";
  // const isManager = user?.role === "companyManager" || user?.role === "customerService" || user?.role === "coordinator";
  // const isFirstClass =
  //   schedule &&
  //   schedule.student &&
  //   schedule.student.studentLevelGrades &&
  //   schedule.student.studentLevelGrades.length === 0 &&
  //   schedule.type !== "trial"
  //     ? true
  //     : false;
  //
  // return (
  //   <>
  //     <CancelDialog
  //       openCancelAlert={cancelAlertOpen}
  //       closeCancelAlert={closeCancelAlert}
  //       cancelSubmit={cancelSubmit}
  //       recurrentSchedule={recurrentSchedule}
  //       sequentialScheduleCancelClasses={sequentialScheduleCancelClasses}
  //       recurrentScheduleId={recurrentScheduleId}
  //       classes={nextClasses}
  //       recurrentScheduleEndDate={recurrentScheduleEndDate}
  //       allSeqClasses={schedule}
  //     />
  //
  //     <div className="listScheduleCard">
  //       <div className="infosAulas">
  //         <h3 className="scheduleDateTime">{schedule.timeTotal}</h3>
  //         <ClassToolCardItem />
  //         {user?.role !== "teacher" && schedule.extraclasses > 0 && (
  //           <h3 className="scheduleDateTime extraClassLabel">
  //             {schedule.extraclasses}{" "}
  //             {schedule.extraclasses === 1 ? t("EXTRA_CLASS_USED_SINGLE") : t("EXTRA_CLASS_USED_PLURAL")}
  //           </h3>
  //         )}
  //       </div>
  //
  //       <div className="scheduleDetails">
  //         <div className="scheduleDetailsInfo">
  //           <div className="scheduleLanguage">
  //             <h4 className="scheduleLanguageName">
  //               <FlagIcon code={schedule.lingoLanguage.flag} />
  //               {t(schedule.lingoLanguage.language.name.toUpperCase())}
  //             </h4>
  //           </div>

  //           <div className="scheduleLanguageDetails">
  //             {schedule?.classScheduleDetails?.length > 0 && (
  //               <h4 className="scheduleLanguageContent">
  //                 {t("CARD_CLASS_CONTENT")}:{" "}
  //                 <span
  //                   className={
  //                     schedule.classScheduleDetails[0].focus.toLowerCase() === "regular" ? "regular" : "specific"
  //                   }
  //                 >
  //                   {schedule.classScheduleDetails[0].focus.toLowerCase() !== "demo class"
  //                     ? t(
  //                         schedule.classScheduleDetails[0].focus.toLowerCase() === "regular"
  //                           ? "BTN_REGULAR"
  //                           : "BTN_SPECIFIC",
  //                       )
  //                     : t("DEMO_CLASS")}
  //                 </span>
  //                 {isFirstClass && ` • ${t("FIRST_CLASS")}`}
  //                 {schedule.type === "trial" && ` • ${t("TRIAL_CLASS")}`}
  //               </h4>
  //             )}
  //
  //             {!isStudent &&
  //               schedule.studentPlan &&
  //               schedule.studentPlan.plan.trial &&
  //               schedule.studentPlan.studentPlanLanguages.length > 0 && (
  //                 <h4 className="scheduleLanguageFocus">
  //                   {`${t("LEVEL")}: ${t(schedule.studentPlan.studentPlanLanguages[0].studentLanguageLevel)}`}
  //                 </h4>
  //               )}
  //           </div>
  //           <div className="scheduleLanguagePeoples">
  //             {(isManager || (isTeacher && hasTeacher)) && (
  //               <h4 className="scheduleLanguagePeople">
  //                 {`${t("CARD_CLASS_STUDENT")}: `}
  //                 {schedule.student ? schedule.student.user.name : ""}
  //                 {schedule.container && schedule.container.studentName ? schedule.container.studentName : ""}
  //               </h4>
  //             )}
  //             {isManager && !!schedule.teacher && (
  //               <h4 className="scheduleLanguagePeople">
  //                 {`${t("CARD_CLASS_TEACHER")}: `}
  //                 {schedule.teacher.user.name}
  //                 {/* {mobilePhone && ` • ${t("CELLPHONE")} - ${mobilePhone}`} */}
  //               </h4>
  //             )}
  //           </div>
  //           {isTeacher && hasTeacher && (
  //             <h4 className="scheduleLanguageLevels">
  //               {t("CARD_PLAN_LEVEL")}:
  //               {schedule.student &&
  //                 schedule.student.studentLevelGrades &&
  //                 schedule.student.studentLevelGrades.map((scheduleLevel) => (
  //                   <Fragment key={JSON.stringify(scheduleLevel)}>{scheduleLevel.level.level}</Fragment>
  //                 ))}
  //               {schedule.container
  //                 ? schedule.container.levelByLingo
  //                   ? schedule.container.levelByLingo
  //                   : schedule.container.levelByStudent
  //                 : ""}
  //             </h4>
  //           )}
  //         </div>
  //         <div className="scheduleActions">
  //           <ConfirmedCardItem />
  //           <CancelCardItem />
  //           <button className="viewSchedule" onClick={() => navigate(`/class-details/${schedule?.id}`)}>
  //             {t("BTN_VIEW")} <i className="fa fa-angle-right"></i>
  //           </button>
  //         </div>
  //       </div>
  //     </div>
  //   </>
  // );

  const isTeacher = user?.role === "teacher";
  const hasTeacher = !!schedule.teacher;
  const isFirstClass =
    schedule &&
    schedule.student &&
    schedule.type !== "trial" &&
    schedule.student.studentLevelGrades &&
    schedule.student.studentLevelGrades.length === 0
      ? true
      : false;

  const ClassToolCardItem = () => {
    //Verfica se o toolId é um link
    const isLink =
      (schedule.student && schedule.student.classToolId && schedule.student.classToolId.indexOf("http") > -1) ||
      (schedule.container && schedule.container.classToolId && schedule.container.classToolId.indexOf("http") > -1);

    // define os dados caso seja uma aula demo ou uma aula normal
    const classTool =
      schedule.student && schedule.student.classTool
        ? schedule.student.classTool
        : schedule.container && schedule.container.classTool
        ? schedule.container.classTool
        : null;

    const classToolId =
      schedule.student && schedule.student.classToolId
        ? schedule.student.classToolId
        : schedule.container && schedule.container.classToolId
        ? schedule.container.classToolId
        : null;

    return classTool && classToolId ? (
      isLink ? (
        <>
          <ButtonClassRoom type="submit" onClick={() => window.open(classToolId)}>
            {t("CLASS_LINK")}
          </ButtonClassRoom>
        </>
      ) : (
        <>
          <ButtonClassRoom>
            {classTool} - {classToolId}
          </ButtonClassRoom>
        </>
      )
    ) : (
      ""
    );
  };

  const LevelStudent = () => {
    const level =
      schedule.student &&
      schedule.student.studentLevelGrades &&
      schedule.student.studentLevelGrades.map((scheduleLevel) => (
        <span key={JSON.stringify(scheduleLevel)}>
          {` • ${t("CARD_PLAN_LEVEL")}: `}
          {scheduleLevel.level.level}
        </span>
      ));

    return level;
  };

  return (
    <Container>
      <DivLeft>
        <ScheduleLanguageName>
          <FlagIcon code={schedule.lingoLanguage.flag} />
          {t(decryptIfEncrypted(schedule.lingoLanguage.language.name).toUpperCase())} {LevelStudent()}
        </ScheduleLanguageName>

        <ScheduleDateTime>{schedule.timeTotal}</ScheduleDateTime>

        <ScheduleLanguagePeople>
          {`${t("CARD_CLASS_STUDENT")}: `}
          <strong>
            {decryptIfEncrypted(schedule?.student ? schedule?.student?.user?.name : schedule?.container.studentName)}
          </strong>
        </ScheduleLanguagePeople>

        {hasTeacher && (
          <ScheduleLanguagePeople>
            {`${t("CARD_CLASS_TEACHER")}: `}
            <strong>{decryptIfEncrypted(schedule?.teacher?.user?.name)}</strong>
          </ScheduleLanguagePeople>
        )}

        {schedule?.classScheduleDetails?.length > 0 && (
          <ScheduleLanguageDetails>
            {t("CARD_CLASS_CONTENT")}:{" "}
            <span
              className={schedule.classScheduleDetails[0].focus.toLowerCase() === "regular" ? "regular" : "specific"}
            >
              {schedule.classScheduleDetails[0].focus.toLowerCase() !== "demo class"
                ? t(schedule.classScheduleDetails[0].focus.toLowerCase() === "regular" ? "BTN_REGULAR" : "BTN_SPECIFIC")
                : t("DEMO_CLASS")}
            </span>
            {isFirstClass && ` • ${t("FIRST_CLASS")}`}
            {schedule.type === "trial" && ` • ${t("TRIAL_CLASS")}`}
          </ScheduleLanguageDetails>
        )}

        {!isTeacher &&
          schedule.teacherLanguageType &&
          schedule.student?.studentLevelGrades[0]?.level?.level !== "A0" &&
          schedule.student?.studentLevelGrades[0]?.level?.level !== "A1" && (
            <ScheduleLanguageDetails>
              {t("TEACHER_TYPE")}:{" "}
              <span className="teacherLanguageType">{t(schedule.teacherLanguageType.toUpperCase())}</span>
            </ScheduleLanguageDetails>
          )}

        {isDevs && <ScheduleLanguageDetails>SequentialClass: {schedule?.sequentialScheduleId}</ScheduleLanguageDetails>}
      </DivLeft>

      <DivRight>
        <WrapperIcons>
          {schedule?.student?.isTraining && (
            <div>
              <label>{t("TRAINING")}</label>
              <FaChalkboardUser size={20} color={"#004fff"} />
            </div>
          )}
          {schedule?.lingoLanguage?.flag === "CS-US-IN" && (
            <div>
              <label>{t("INTERVIEW")}</label>
              <IoPeopleCircle size={20} color={"#004fff"} />
            </div>
          )}
        </WrapperIcons>

        <WrapperButton>
          <ButtonView onClick={() => navigate(`/class-details/${schedule?.id}`)}>{t("BTN_VIEW")}</ButtonView>
          {ClassToolCardItem()}
        </WrapperButton>
      </DivRight>
    </Container>
  );
}

export default CardSchedule;
